export default __webpack_public_path__ + "static/media/thunderstorm-day.a753fb01.svg";